/* global Swiper */
// **********************************************************
// Image Slider
// **********************************************************

const imageSliderSwiperElements = document.querySelectorAll('[data-slider="image-slider"]');
const imageSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    prevEl: '.swiper-button-next',
    nextEl: 'swiper-button-prev',
  },
  effect: 'creative',
  creativeEffect: {
    prev: {
      shadow: true,
      translate: [0, 0, -400],
    },
    next: {
      translate: ['100%', 0, 0],
    },
  },
};

imageSliderSwiperElements.forEach((el) => {
  const imageSliderParent = el.closest('.image-slider');
  const arrowRight = imageSliderParent.querySelector('.arrow-right');
  const arrowLeft = imageSliderParent.querySelector('.arrow-left');

  imageSliderOptions.navigation.nextEl = arrowRight;
  imageSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  new Swiper(el, imageSliderOptions);
});
